import React from "react";

const Switch = (props: { active?: boolean; onClick: () => void }) => {
  return (
    <div
      className={`pyht-switch ${props.active ? "active" : ""}`}
      onClick={() => props.onClick()}
      role="checkbox"
      aria-checked={props.active ? "true" : "false"}
    >
      <div className={"handle"} />
    </div>
  );
};

export default Switch;
